import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-canvas-header',
  templateUrl: './canvas-header.component.html',
  styleUrls: ['./canvas-header.component.scss']
})
export class CanvasHeaderComponent {

  @Input() title: string = ''; @Input() top = 0; @Input() isTopPercentage = true; @Input() isPopup = true;
  @Output() onRefresh = new EventEmitter(); @Input() isRefresh = false;
  @Output() onClose = new EventEmitter();

  constructor(public localService: LocalService) { }

  ngOnInit(): void {
  }

  onCloseTrigger() {
    this.onClose.emit();
  }

  ngOnDestroy(): void {
  }

  onRefreshTrigger() {
    this.onRefresh.emit();
  }

}
